import { gql } from "@apollo/client";

export default gql`
  query getAiProfile($customerId: ID!, $role: AiRoleEnum){
    getAiProfile(customerId: $customerId, role: $role){
        success
        data{
            _id
            customer
            role
            storeSettings{
                integrationStore
                shoppingAssistant{
                    recommendSimilarProducts
                    productFaqs
                    promoteProducts
                    takeOrders
                    collectAddress
                    cashOnDelivery
                    cardOnDelivery
                    bankTransfer
                    bankAccounts{
                        bankName
                        iban
                        accountHolder
                    }
                    cancelOrders
                    updateOrders
                    returnOrders
                    addToCart
                }
                productFaqDesign{
                    showIcons
                    iconColor
                    textColor
                    fontSize
                    fontWeight
                    borderColor
                    borderWidth
                    borderRadius
                    fontFamily
                    answerLength
                }
                useProductImagesForRag
            }
            lastSelectedAt
            isActive
            name
            avatar
            persona
            toneOfVoice
            useEmoji
            aiImageRecognition
            chatSettings{
                status
                aiIntroducesItself
                aiReplyButtons{
                    aiHelped{
                        buttonTitle
                        isButtonEnabled
                        action
                        actionValue
                        actionMessage
                        addClosingTag
                        addClosingNote
                        sendSurvey
                    }
                    humanSupport{
                        buttonTitle
                        isButtonEnabled
                        action
                        actionValue
                        actionMessage
                    }
                }
                aiAutoClose{
                    waitTimeInSecond
                    actionMessage
                }
                aiFollowUp{
                    mode
                    waitTimeInSecond
                }
                humanHandoff{
                    isDisabled
                    channels
                    message
                }
                aiAgentWorkingHours
                channels
            }
            emailSettings{
                status
                aiIntroducesItself
                aiAutoClose{
                    waitTimeInSecond
                    actionMessage
                }
                aiFollowUp{
                    mode
                    waitTimeInSecond
                }
                aiAgentWorkingHours
                channels
            }
            commentSettings{
                status
                replyToComment
                sendPrivateReply
                aiAgentWorkingHours
                channels
            }
            ticketSettings{
                status
                aiAutoClose{
                    waitTimeInSecond
                    actionMessage
                }
                aiFollowUp{
                    mode
                    waitTimeInSecond
                }
                aiAgentWorkingHours
                channels
            }
            marketPlaceSettings{
                status
                aiAgentWorkingHours
                channels
                replyMode
            }
            createdAt
            updatedAt
            answerLength
            useMacrosAsKnowledgeSource
            learnFromHumanReplies
            humanReplyLearningJobId
        }
        code
        message
    }
}
`
